import { NA_SINGLE_ITEM, NA_SINGLE_ITEM_ERROR, NA_SINGLE_ITEM_SUCCESS } from '../../constants';
const initialState = { response: {}, error: false, isLoading: false };
const naSingleItemReducer = (state = initialState, action) => {
    switch (action.type) {
        case NA_SINGLE_ITEM:
            return {
                ...state,
                isLoading: true,
            };
        case NA_SINGLE_ITEM_SUCCESS:
            return {
                ...state,
                response: action.response,
                error: false,
                isLoading: false,
            };
        case NA_SINGLE_ITEM_ERROR:
            return {
                ...state,
                error: true,
                isLoading: false,
            };
        default:
            return state;
    }
};
export default naSingleItemReducer;
